import { Controller } from "@hotwired/stimulus"
import { decode } from "blurhash"

export default class extends Controller {
  static values = {
    hash: String,
    width: { type: Number, default: 32 },
    height: { type: Number, default: 32 }
  }

  static targets = ["canvas", "image"]

  connect() {
    this.renderBlurhash()
    this.setupImageLoad()
  }

  renderBlurhash() {
    if (!this.hasCanvasTarget || !this.hashValue) return

    const canvas = this.canvasTarget
    const ctx = canvas.getContext("2d")

    canvas.width = this.widthValue
    canvas.height = this.heightValue

    const pixels = decode(this.hashValue, this.widthValue, this.heightValue)
    const imageData = ctx.createImageData(this.widthValue, this.heightValue)
    imageData.data.set(pixels)
    ctx.putImageData(imageData, 0, 0)
  }

  setupImageLoad() {
    if (!this.hasImageTarget) return

    const img = this.imageTarget.querySelector("img") || this.imageTarget

    if (img.complete) {
      this.fadeInImage()
    } else {
      img.addEventListener("load", () => this.fadeInImage())
    }
  }

  fadeInImage() {
    if (this.hasImageTarget) {
      this.imageTarget.classList.add("loaded")
    }
    if (this.hasCanvasTarget) {
      this.canvasTarget.classList.add("fade-out")
    }
  }
}
